export const ACCRUALS_ASSETS = {
  HEADER_INFO: '/img/accruals/header-info.svg',
  ARROW_RIGHT: '/img/accruals/arrow-right.svg',
  ARROW_RIGHT_MUTED: '/img/accruals/arrow-right-muted.svg',
  HERO_ILLUSTRATION: '/img/accruals/AccrualsHeroBg.svg',
  ICON_FILTER: '/img/accruals/icon-filter-horizontal.svg',
  ICON_RELOAD: '/img/icons/fbc-icons/RefreshIcon.svg',
  ICON_FILE: '/img/accruals/icon-file-master.svg',
  ICON_INFO_REQUEST: '/img/navicon/fbc-nav/InfoRequest.svg',
  ICON_MAIL: '/img/accruals/icon-mail.svg',
  ICON_CONSARK_AI: '/img/accruals/icon-consark-ai.svg',
  ICON_CLOSE: '/img/accruals/icon-close.svg',
  ICON_TICK: '/img/accruals/icon-tick.svg',
  ICON_CHECK_WHITE: '/img/accruals/icon-check-white.svg',
  ICON_APPROVE: '/img/accruals/icon-approve.svg',
  ICON_DATABASE: '/img/accruals/icon-database.svg',
  ICON_SYNC: '/img/accruals/icon-sync.svg',
  ICON_SYNC_STATUS: '/img/accruals/icon-sync-status.svg',
  ESTIMATES_PLAY_WHITE: '/img/accruals/estimates/icon-play-white.svg',
  ESTIMATES_OVERFLOW_DOTS: '/img/accruals/estimates/icon-overflow-dots.svg',
  ESTIMATES_ADD: '/img/accruals/estimates/icon-add.svg',
  ESTIMATES_ADD_WHITE: '/img/accruals/configuration/icon-plus-white.svg',
  ESTIMATES_ARROW_RIGHT: '/img/accruals/estimates/icon-arrow-right.svg',
  ESTIMATES_SPARKLE: '/img/accruals/estimates/Sparkle.svg',
  ESTIMATES_UPLOAD: '/img/accruals/estimates/icon-upload.svg',
  ESTIMATES_EXTERNAL_LINK: '/img/accruals/estimates/icon-external-link.svg',
  ESTIMATES_SYNC_INFO_REQUEST: '/img/accruals/estimates/IconSyncInfo.svg',
  ESTIMATES_SPLIT_VIEW: '/img/accruals/estimates/SidePanel.svg',
  ESTIMATES_ROW_CHEVRON: '/img/accruals/estimates/icon-row-chevron.svg',
  ESTIMATES_STEP_CHECK: '/img/accruals/estimates/icon-step-check.svg',
  SCHEDULE_DOWNLOAD: '/img/accruals/estimates/icon-download-je.svg',
  SCHEDULE_COMMENT: '/img/icons/fbc-icons/CommentsIcon.svg',
  ICON_RERUN: '/img/accruals/RerunPlay.svg'
};

export const ACCRUALS_METRIC_KEYS = {
  OPEN_PO: 'open_po',
  AP_POSTINGS: 'ap_postings',
  ACCRUALS_LEDGER: 'accruals_ledger',
  VENDOR_MASTER: 'vendor_master',
};

export const ACCRUALS_ROUTES = {
  home: (projectId) => `/financialclose/automationaccruals/${projectId}`,
  estimates: (projectId) => `/financialclose/automationaccruals/${projectId}/estimates`,
  data: (projectId) => `/financialclose/automationaccruals/${projectId}/data`,
  configuration: (projectId, query = {}) => {
    const params = new URLSearchParams();
    if (query.tab) params.set('tab', query.tab);
    if (query.view) params.set('view', query.view);
    const qs = params.toString();
    const base = `/financialclose/automationaccruals/${projectId}/configuration`;
    return qs ? `${base}?${qs}` : base;
  },
};

export const ACCRUALS_CONFIGURATION_OPTIONS = [
  {
    id: 'import-previous-cycle',
    title: 'Import from previous cycle',
    subtitle: 'Feb 2026 · 4 rules',
    icon: ACCRUALS_ASSETS.ICON_RELOAD,
    badge: 'FASTEST',
  },
  {
    id: 'estimation-rules',
    title: 'Estimation Rules',
    subtitle: 'No rules configured',
    icon: ACCRUALS_ASSETS.ICON_FILE,
  },
  {
    id: 'info-request-rules',
    title: 'Info Request Rules',
    subtitle: 'No rules configured',
    icon: ACCRUALS_ASSETS.ICON_INFO_REQUEST,
  },
];

export function formatRulesCountSubtitle(count = 0) {
  const value = Number(count) || 0;
  if (value === 0) return 'No rules configured';
  return value === 1 ? '1 rule' : `${value} rules`;
}

